/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CardTransactionRecord
 */
export interface CardTransactionRecord {
    /**
     * 
     * @type {number}
     * @memberof CardTransactionRecord
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionRecord
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionRecord
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionRecord
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionRecord
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionRecord
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionRecord
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionRecord
     */
    'transactionDetailType': CardTransactionRecordTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionRecord
     */
    'isCleared': boolean;
}

export const CardTransactionRecordTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type CardTransactionRecordTransactionDetailTypeEnum = typeof CardTransactionRecordTransactionDetailTypeEnum[keyof typeof CardTransactionRecordTransactionDetailTypeEnum];


